import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Environment } from '@r1-compass-library/environments/environment';
import {
    TemplateCriteria,
    TemplateCriteriaConfig,
} from '@r1-compass-library/models/template-criteria/template-criteria.model';
import { Observable, catchError, finalize, of } from 'rxjs';
import { HttpHeaderConstants } from '@r1-compass-library/constants';
import { TemplateCriteriaSearch } from '@r1-compass-library/models/search/template-criteria-search.model';
import { AssetRestService } from './rest/asset-rest.service';

@Injectable({
    providedIn: 'root',
})
export class TemplateCriteriaService extends AssetRestService<TemplateCriteria, TemplateCriteriaSearch> {
    protected override BASE_URL: string = Environment.baseUrl + '/frontend/template-criteria';
    protected override TARGET_OBJECT = 'template-criteria';

    processNamePrefix = 'TemplateCriteriaService';

    updateData(id: number, data: TemplateCriteriaConfig): Observable<TemplateCriteria> {
        const httpOptions = {
            headers: new HttpHeaders({
                ...HttpHeaderConstants.defaultHeaders,
                ...HttpHeaderConstants.mergePatch,
            }),
        };
        const process = 'TemplateCriteriaService.updateData';
        this.spinnerService.addProcess(process, 'Updating template criteria data...');
        return this.http
            .patch<TemplateCriteria>(`${this.BASE_URL}/${id}/data?fieldName=config`, data, httpOptions)
            .pipe(
                catchError(error => {
                    return of<TemplateCriteria>();
                }),
                finalize(() => this.spinnerService.completeProcess(process))
            );
    }
}
